/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import { createSlice } from '@reduxjs/toolkit';
import { SurveyOverviewMode } from '@g17eco/types/surveyOverview';

interface InitialState {
  overviewMode: SurveyOverviewMode;
  isShowingMappedMetrics: boolean;
}

const initialState: InitialState = {
  overviewMode: SurveyOverviewMode.ScopeGroups,
  isShowingMappedMetrics: false,
};

const surveySettingsSlice = createSlice({
  name: 'surveySettings',
  initialState,
  reducers: {
    setOverviewMode: (state, action) => {
      return { ...state, overviewMode: action.payload }
    },
    setShowingMappedMetrics: (state, action) => {
      return { ...state, isShowingMappedMetrics: action.payload }
    },
  }
})

const { actions } = surveySettingsSlice;

export const setOverviewMode = (mode: SurveyOverviewMode) => (dispatch: any, getState: () => { surveySettings: InitialState }) => {
  if (getState().surveySettings.overviewMode === mode) {
    return;
  }

  dispatch(actions.setOverviewMode(mode));
}

export const setShowingMappedMetrics = (isShowingMappedMetrics: boolean) => (dispatch: any) => {
  dispatch(actions.setShowingMappedMetrics(isShowingMappedMetrics));
}

export default surveySettingsSlice.reducer
